<template>
	<button class="arrow-button text-small" @click="goBack()">{{ title }}</button>
</template>

<script>
export default {
	props: {
		theme: {
			type: String,
			default: 'default',
		},
		title: {
			type: String,
			default: 'Tilbake',
		},
	},
	data() {
		return {
			buttonTheme: this.theme,
		}
	},
	computed: {},
	methods: {
		goBack() {
			return this.$router.push({ path: '/' })
		},
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_color.scss';
.arrow-button {
	&::before {
		content: '<--';

		font-size: 1.1rem;

		top: 0;
		right: 70px;
		transition: 0.5s;
		margin-right: 0.3rem;
	}

	&:hover::before {
		transition: 1s;
		padding-right: 10px;
	}
}
</style>
